export default {
  text: 'ファイルをここにドラッグ＆ドロップするか、<em>クリックしてアップロード</em>',
}
